import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { SupportEmail } from "./PolicyPage";

function Returns() {
  return (
    <PolicyPage title="Refund & Return Policy">
      <p>
        <strong>Return eligibility</strong>
        <br />
        We accept eligible returns for items purchased directly from this
        website. Unless an item is defective or mandatory law provides
        otherwise, it must be unworn, unaltered, undamaged, and returned with all
        original packaging, tags, certificates, and included accessories.
      </p>
      <p>
        <strong>Return window</strong>
        <br />
        Contact us promptly and ensure an authorized return reaches the address
        we provide within 7 business days after delivery. If applicable consumer
        law gives you a longer cancellation or return period, that mandatory
        period applies instead.
      </p>
      <p>
        <strong>Non-returnable items</strong>
        <br />
        Customized, engraved, resized, altered, personalized, made-to-order, and
        clearly marked final-sale items are not returnable for change of mind.
        Hygiene-sensitive items may also be excluded after use. These exclusions
        do not apply where an item is faulty, materially misdescribed, supplied
        incorrectly, or where applicable law does not permit the exclusion.
      </p>
      <p>
        <strong>Starting a return</strong>
        <br />
        Email <SupportEmail /> with your order number, item name, reason for the
        return, and photographs where relevant. Do not send an item before you
        receive return authorization and the correct return address. Parcels
        sent elsewhere may be delayed or lost.
      </p>
      <p>
        <strong>Return shipping</strong>
        <br />
        For a discretionary return, the customer is responsible for return
        shipping. Use a tracked service with adequate insurance and signature
        confirmation, and retain the receipt. If we confirm that an item is
        faulty, damaged on arrival, or incorrect, we will provide or reimburse a
        reasonable return method where required.
      </p>
      <p>
        <strong>Inspection and deductions</strong>
        <br />
        We inspect returned items before approval. A 10% restocking fee applies
        to approved discretionary returns. Original delivery charges are not
        refundable unless required by law. Where lawful, we may reduce a refund
        for loss in value caused by handling beyond what is reasonably needed to
        inspect the item, missing contents, or avoidable return damage.
      </p>
      <p>
        <strong>Refund method and timing</strong>
        <br />
        Approved refunds are issued to the original payment method, less any
        disclosed lawful deduction, within 5–10 business days after inspection.
        Your bank may need additional time to post the credit. If the original
        method is unavailable, we will discuss a lawful alternative.
      </p>
      <p>
        <strong>Exchanges</strong>
        <br />
        We do not currently process direct exchanges or store credit through the
        website. An eligible item may be returned and a new order placed
        separately. Availability and price are not reserved while a return is in
        transit.
      </p>
      <p>
        <strong>Damaged, incorrect, or missing items</strong>
        <br />
        Inspect the parcel promptly. Report visible transit damage, an incorrect
        item, or missing contents within 24 hours after delivery where reasonably
        possible, and preserve the packaging. This reporting request helps us
        investigate with the carrier and does not remove mandatory rights. After
        verification, we will arrange an appropriate repair, replacement, price
        reduction, or refund.
      </p>
      <p>
        <strong>Late or missing refunds</strong>
        <br />
        First check with the payment issuer because posting can take time. If the
        expected period has passed, contact us with the order number. Payment and
        authorization details are in our <Link to="/payments">Payment Policy</Link>.
      </p>
      <p>
        <strong>Abusive returns and rights preserved</strong>
        <br />
        We may reject a return involving substitution, counterfeit goods,
        deliberate damage, false tracking, or other fraud, and may preserve
        evidence or report unlawful activity. Nothing in this policy excludes a
        statutory guarantee, warranty, remedy, or cancellation right that cannot
        be excluded by agreement.
      </p>
    </PolicyPage>
  );
}

export default Returns;
